import { people } from "@/mocks/gua";
import SectionTitle from "./SectionTitle";

export default function People() {
  return (
    <section id="people" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-8 px-4 md:px-6">
        <SectionTitle
          eyebrow="热门人物"
          title="最近被反复提起的这些脸"
          desc="从剧集、综艺到直播间，盘点近期高频登上热榜、最被大家讨论的那群人。"
        />

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5">
          {people.map((person) => (
            <article
              key={person.id}
              className="group flex flex-col rounded-2xl bg-background-100 p-4 transition-colors hover:bg-background-200/60"
            >
              <div className="relative mx-auto h-24 w-24 overflow-hidden rounded-full ring-4 ring-white md:h-28 md:w-28">
                <img
                  src={person.image}
                  alt={person.title}
                  className="h-full w-full object-cover"
                />
                <span className="absolute inset-0 rounded-full ring-1 ring-inset ring-background-200" />
              </div>
              <div className="mt-3 flex items-center justify-center">
                <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-bold text-secondary-900">
                  {person.scene}
                </span>
              </div>
              <h3 className="mt-3 text-center font-heading text-base font-black text-foreground-900">
                {person.title}
              </h3>
              <p className="mt-1 text-center text-xs font-semibold text-primary-600">{person.keywords}</p>
              <p className="mt-2 flex-1 text-center text-xs leading-relaxed text-foreground-600">{person.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}